import React, { Fragment } from 'react';
import {
  Box as Wrapper,
  Icon,
  Menu,
  MenuList,
  MenuItem,
  MenuDivider,
  MenuToggle,
  MenuToggleIcon,
  Button,
} from '@tonic-ui/react';

const MenuButton = ({ isMenuToggleVisible = true, children, ...rest }) => {
  // Define custom styles for the menu button

  const styleProps = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '1x',
    borderBottomRightRadius: '0rem',
    borderBottomLeftRadius: '0rem',
    _hover: {
      backgroundColor: 'rgba(56, 56, 56, 1)',
    },
    _selected: {
      backgroundColor: 'rgba(56, 56, 56, 1)',
    },
  };

  return (
    <MenuToggle>
      {({ getMenuToggleProps }) => {
        const menuToggleProps = getMenuToggleProps();
        return (
          <Button
            {...menuToggleProps}
            {...styleProps}
            {...rest}
            aria-selected={menuToggleProps['aria-expanded']}
          >
            {children && <Wrapper>{children}</Wrapper>}

            {isMenuToggleVisible && <MenuToggleIcon />}
          </Button>
        );
      }}
    </MenuToggle>
  );
};

const DropdownMenu = ({
  id,
  tabIndex = 0,
  menuList,
  selectedItem,
  onChange,
  menuButtonProps,
  menuListProps,
  isResponsive,
  isSeparatorVisible = false,
  truncateString = false,
  placement = 'bottom-end', // most of the dropdowns are right aligned so defaulting to bottom-end
}) => {
  const handleClick = (event, value) => {
    if (event?.key === 'Enter' || event?.type === 'click') {
      onChange(value);
    }
  };

  const conditionalProps = {
    textOverflow: 'ellipsis',
    maxWidth: '200px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  };

  const menuSize = menuList.length;

  return (
    <>
      {selectedItem ? (
        <Menu id={id} data-id={id} placement={placement}>
          <MenuButton
            variant="ghost"
            style={{ userSelect: 'text' }}
            data-id={`${id}-menuButton`}
            data-ux-id={`${id}-menuButton`}
            tabIndex={tabIndex}
            {...menuButtonProps}
          >
            {
              // This is the support-dropdown which will show icon on smaller screen
              isResponsive ? (
                <>
                  <Wrapper display={{ sm: 'block', md: 'none' }}>
                    <Icon icon="menu" size="6x" verticalAlign="top" />
                  </Wrapper>
                  <Wrapper
                    {...(truncateString && conditionalProps)}
                    display={{ sm: 'none', md: 'block' }}
                  >
                    {selectedItem?.label ? selectedItem.label : selectedItem}
                  </Wrapper>
                </>
              ) : (
                <Wrapper {...(truncateString && conditionalProps)}>
                  {selectedItem?.label ? selectedItem.label : selectedItem}
                </Wrapper>
              )
            }
          </MenuButton>
          <MenuList
            zIndex="2000"
            minWidth="100%"
            whiteSpace="nowrap"
            overflow="auto"
            {...menuListProps}
          >
            {menuList.map((menuItem, index) => {
              const isLast = index === menuSize - 1;

              return (
                <Fragment key={`${id}-menuItemBox-${menuItem.value}`}>
                  {menuItem.label === 'showMenuDivider' ? (
                    <MenuDivider />
                  ) : (
                    <MenuItem
                      data-id={`menuItem-${menuItem.value}`}
                      data-ux-id={`${id}-menuItem-${menuItem.value}`}
                      disabled={menuItem.disabled}
                      onClick={(e) => handleClick(e, menuItem)}
                      onKeyDown={(e) => handleClick(e, menuItem)}
                      {...(isSeparatorVisible &&
                        !isLast && {
                          borderBottom: 1,
                          borderBottomColor: 'gray:100',
                        })}
                    >
                      {menuItem.label}
                    </MenuItem>
                  )}
                </Fragment>
              );
            })}
          </MenuList>
        </Menu>
      ) : null}
    </>
  );
};

export default DropdownMenu;
